export const THRESHOLDS = {
  callsInQueue: { critical: 11 }, //CHANGE HERE (CALLS WAITING)
  longestWaitTime: { critical: 900 }, // seconds CHANGE HERE (AVERAGE WAIT TIME)
  averageHandleTime: { critical: 900 }, // seconds CHANGE HERE (AVERAGE TALK TIME)
  abandonedCalls: { critical: 51 }, // percentage CHANGE HERE (ABANDONED CALLS)
  contactsMissed: { critical: 51 }, //CHANGE HERE (MISSED CALLS)
  uniqueAgentsCount: { critical: 1 },  // CHANGE HERE (ACTIVE AGENTS)
  abandonmentRate: { critical: 21 }, // percentage CHANGE HERE (ABANDONMENT RATE)
};

export type ThresholdStatus = 'normal' | 'critical';

export const getThresholdStatus = (
  value: number,
  thresholds: { critical: number },
  isMinimum = false
): ThresholdStatus => {
  if (isMinimum) {
    if (value < thresholds.critical) return 'critical';
  } else {
    if (value >= thresholds.critical) return 'critical';
  }
  return 'normal';
};